<template>
  <div>
    <v-row>
      <v-col cols="10">
        <h1>{{ $t("optima.title") }}</h1>
      </v-col>
      <v-spacer />
      <v-tooltip top>
        {{ $t("global.settings") }}
        <template v-slot:activator="{ on }">
          <v-btn large icon v-on="on" @click="$router.push('/optima/settings/category')"><v-icon x-large>fa-cog</v-icon></v-btn>
        </template>
      </v-tooltip>
    </v-row>
    <v-form lazy-validation ref="form">
      <select-delegation-by-criteria-component
        :delegation_ids.sync="delegation_ids"
        get-delegations-address="/optima/get-delegations"
        get-filter-data-address="/optima/get-filters-data"
      >
        <template v-slot:action="{ item }">
          <v-tooltip top>
            {{ $t("global.downloadFile") }}
            <template #activator="{on}">
              <v-btn icon @click="downloadDelegation(item.id)" v-on="on">
                <v-icon>mdi-file-download</v-icon>
              </v-btn>
            </template>
          </v-tooltip>
        </template>
      </select-delegation-by-criteria-component>
      <v-row>
        <v-spacer />
        <v-btn class="accent" @click="generate">{{ $t("optima.generate") }}</v-btn>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import SelectDelegationByCriteriaComponent from "../../components/SelectDelegationByCriteriaComponent";
import downloadFile from "../../repository/downloadFile";
export default {
  name: "OptimaView",
  components: { SelectDelegationByCriteriaComponent },
  data: () => ({
    delegation_ids: []
  }),
  methods: {
    downloadDelegation(id) {
      downloadFile("optima/download-settlement?delegationId=" + id);
    },
    generate() {
      downloadFile("optima/download-export", "GET", { delegation_ids: this.delegation_ids });
    }
  }
};
</script>

<style scoped></style>
